import { VoucherSettingsAdapter as t } from "./voucherSettings/voucherSettings.adapter.js";
import { Adapter as i, getAdapter as r } from "../../adapter.js";
import { VoucherModel as n } from "./voucher.model.js";
class p extends i {
  adapt(e) {
    return new n({
      internalCode: e.internal_code,
      internalShortCode: e.internal_short_code,
      url: new URL(e.url),
      status: e.status,
      initialDate: new Date(e.initial_date * 1e3),
      settings: r(t).adapt(e.settings),
      expirationDate: e.expiration_date ? new Date(e.expiration_date * 1e3) : void 0,
      text: e.text,
      code: e.code,
      internalSharedShortCode: e.internal_shared_short_code,
      currentUses: e.current_uses,
      detailedStatus: e.detailed_status,
      nextActivationTimestamp: e.next_activation_timestamp ? new Date(e.next_activation_timestamp * 1e3) : void 0
    });
  }
  serialize(e) {
  }
}
export {
  p as VoucherAdapter
};
//# sourceMappingURL=voucher.adapter.js.map
